import styled from '@emotion/styled';

export const SFiltersContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  height: 88px;
  
  & .iban-input {
    min-width: 320px;
  }
  & .ant-form-inline .ant-space {
    align-items: flex-start;
  }
`;
